module.exports = __webpack_public_path__ + "media/images/icons/flat-color-square-facebook-db1019127921ba0845e869d2e3e6edd3.png";